import { Component } from '@opten/compiler/metadata/component';

@Component({ className: 'js-special-button' })
export class SpecialButton {
	constructor(public element: HTMLElement) {
		this.element.addEventListener('mousemove', (e) => {
			const x = e.pageX - this.element.getBoundingClientRect().left - window.scrollX;
			const y = e.pageY - this.element.getBoundingClientRect().top - window.scrollY;

			this.element.style.setProperty('--x', `${ x }px`);
			this.element.style.setProperty('--y', `${ y }px`);
		});
	}
}
